import { Route } from "react-router-dom";
import { SimpleErrorBoundary } from "~/components";
import { lazyPage } from "~/utils/routing/lazyPage";
import { FinancePageLoader, FinancePageAction } from "./FinancePage/loaders";
import {
  PropertyFinancePageLoader,
  PropertyFinancePageAction,
} from "./PropertyFinancePage/loaders";
import { financePageShouldRevalidate } from "./utils/financePageTabs";

const FinancePage = lazyPage(() =>
  import(
    /* webpackChunkName: "finance" */
    "./FinancePage/FinancePage"
  ).then((m) => ({ default: m.FinancePage })),
);
const PropertyFinancePage = lazyPage(() =>
  import(
    /* webpackChunkName: "finance" */
    "./PropertyFinancePage/PropertyFinancePage"
  ).then((m) => ({
    default: m.PropertyFinancePage,
  })),
);

export const FinancePagesRoutes = () => {
  return (
    <>
      <Route
        path="/finance"
        loader={FinancePageLoader}
        action={FinancePageAction}
        shouldRevalidate={financePageShouldRevalidate}
        ErrorBoundary={() => SimpleErrorBoundary()}
        element={<FinancePage />}
      />
      <Route
        path={`/finance-details/:propertyID`}
        loader={PropertyFinancePageLoader}
        action={PropertyFinancePageAction}
        shouldRevalidate={financePageShouldRevalidate}
        ErrorBoundary={() => SimpleErrorBoundary()}
        element={<PropertyFinancePage />}
      />
    </>
  );
};
